import './App.css';

function SupportUs() {
  return (
      <div className="contentDiv">
        <h1 className="contentHeader">Support Us</h1>
        <h3 className="contentSubHeader">Purchase T Shirts</h3>
        <p><a href="https://docs.google.com/forms/d/e/1FAIpQLSd9uxOMlXxh4QSHYinnc74W3EKou2kGoF_mQe5mNbHbAA6Zgw/viewform">Click here</a> to order T Shirts. A staff member will reach out to you for payment and delivery/pickup information.</p>
        <h3 className="contentSubHeader">Donate</h3>
        <p>Coming soon.</p>
      </div>
  );
}

export default SupportUs;
